import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CJRButton } from '../../basicComponents/cjrButton/cjrButton';
import {
  selectCookieConsentVisible,
  setCookieConsentVisible,
} from '../../redux/slices/cookieConsent.slice';
import { useWindowDimensions } from '../../hooks/useWindowDimensions';

export const CookieConsent = () => {
  const isVisible = useSelector(selectCookieConsentVisible);
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true,
    analytics: false,
  });

  useEffect(() => {
    setShowPreferences(false);
    setPreferences({
      essential: true,
      analytics: false,
    });
  }, [isVisible]);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      dispatch(setCookieConsentVisible(true));
    }
  }, [dispatch]);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({ essential: true, analytics: true }));
    dispatch(setCookieConsentVisible(false));
  };

  const handleSavePreferences = () => {
    localStorage.setItem('cookieConsent', JSON.stringify(preferences));
    dispatch(setCookieConsentVisible(false));
  };

  const handleRejectAll = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({ essential: true, analytics: false }));
    dispatch(setCookieConsentVisible(false));
  };

  const togglePreference = (key: keyof typeof preferences) => {
    setPreferences((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        background: 'var(--background)',
        color: 'var(--foreground)',
        padding: '15px',
        textAlign: 'center',
        zIndex: 10000,
        boxShadow: 'var(--shadow-card)',
        borderTop: '1px solid var(--border)',
        font: "500 16px var(--font-body)",
      }}
    >
      {!showPreferences ? (
        <>
          <p style={{ marginBottom: '15px', fontSize: '14px', lineHeight: '1.5' }}>
            We use cookies to improve your experience. By clicking "Accept All", you agree to our
            use of cookies.
            <a
              href="https://cozyjuicyreal.com/privacy-policy"
              style={{ color: 'var(--primary)', fontWeight: 600, textDecoration: 'none', marginLeft: '5px' }}
            >
              Privacy Policy
            </a>
            .
          </p>
          <div
            style={{
              display: 'flex',
              flexDirection: width < 600 ? 'column' : 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              marginTop: '30px',
            }}
          >
            <CJRButton
              onClick={handleAcceptAll}
              variant="juicyPrimary"
              style={{ maxWidth: '230px', width: '100%' }}
            >
              Accept All
            </CJRButton>
            <CJRButton
              onClick={() => setShowPreferences(true)}
              variant="secondary"
              style={{ maxWidth: '230px', width: '100%' }}
            >
              Customize Preferences
            </CJRButton>
            <CJRButton
              onClick={handleRejectAll}
              variant="secondary"
              style={{ maxWidth: '230px', width: '100%' }}
            >
              Reject All
            </CJRButton>
          </div>
        </>
      ) : (
        <>
          <p style={{ marginBottom: '15px', fontSize: '14px', lineHeight: '1.5' }}>
            Customize your cookie preferences:
          </p>
          <div style={{ marginBottom: '10px' }}>
            <label>
              <input type="checkbox" checked={preferences.essential} disabled />
              Essential (always enabled)
            </label>
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label>
              <input
                type="checkbox"
                checked={preferences.analytics}
                onChange={() => togglePreference('analytics')}
              />
              Analytics - Helps us understand how our website is used.
            </label>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: width < 600 ? 'column' : 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              marginTop: '30px',
            }}
          >
            <CJRButton
              onClick={handleSavePreferences}
              variant="juicyPrimary"
              style={{ maxWidth: '200px', width: '100%' }}
            >
              Save Preferences
            </CJRButton>
            <CJRButton
              onClick={() => setShowPreferences(false)}
              variant="secondary"
              style={{ maxWidth: '200px', width: '100%' }}
            >
              Back
            </CJRButton>
          </div>
        </>
      )}
    </div>
  );
};
